import React, { useState } from 'react'
import { Card, Row, Col, Form } from "react-bootstrap"
import * as FormFields from "../../components/formcomponents"
import { BlueBorderButton, BlueButton, CancelButton } from '../../components/buttoncomponents'
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useFormik } from 'formik';
import { ContactTypeList, ContactTypeListSupplier } from '../../helpers/API/Api';
import { useEffect } from 'react';
import * as CONFIG from "../../helpers/config.js"
import axios from "axios"
import { useMsal } from "@azure/msal-react";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Moment from "moment";

export const InsitutionList = (props) => {
    console.log(props)
    const { instance } = useMsal();
    const [list, setList] = useState([]);
    const [isFirst, setIsFirst] = useState(true);
    console.log('give', props.contactTypeID)
    useEffect(() => {
        if (isFirst) {
            axios.post(CONFIG.TMS_SERVER_URL + CONFIG.GET_FINANCIAL_INSTITUTE_LIST, {
                "instanceID": CONFIG.PMSInstanceID,
                "accountSubscriptionID": CONFIG.AccountSubscriptionID,
                "created_User": CONFIG.LoginID,
            }, { headers: { "Authorization": `Bearer ${CONFIG.AuthToken}`, "Ocp-Apim-Subscription-Key": CONFIG.API_KEY } })
                .then((res) => {
                    console.log(res.data.result)
                    setList(res.data.result)
                }).catch((error) => {
                    if (error.response.status == 401) {
                        localStorage.clear();
                        instance.logoutRedirect({
                            postLogoutRedirectUri: "/",
                        });
                    }
                })
        } else {
            setIsFirst(false)
        }
    }, [isFirst])

    return (
        <>
            {list.map((li, k) => {
                if(li.institute.financialInstituteID != props.defualtInstitute){
                    return (
                        <option
                            key={k}
                            value={li.institute.financialInstituteID}
                            defaultValue={li.institute.financialInstituteID == props.financialInstituteID}
                            selected={props.financialInstituteID == li.institute.financialInstituteID}>
                            {li.institute.bank.bankName}
                        </option>
                    )
                }
            })}
        </>
    )
}




export default function Add_contact(props) {
    console.log(props)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [linkText, setLinkText] = useState('')
    const [linkType, setLinkType] = useState(0)
    const [title, setTitle] = useState('')
    const [doc, setDoc] = useState(false)
    const [contactTypeList, setContactTypeList] = useState([])
    const { instance } = useMsal();
    const [isnewemployment, setIsnewemployment] = useState(false)
    let [historylist, setHistorylist] = useState([])
    const [iscontactset, setIscontactset] = useState(false)
    const [isnewcontactset, setIsnewcontactset] = useState(false)

    const [listbox, setListbox] = useState({
        options: [],
        getOptionLabel: (option) => { }
    })


    useEffect(() => {
        axios.post(CONFIG.TMS_SERVER_URL + CONFIG.GET_FINANCIAL_INSTITUTE_CONTACT_TYPE_LIST, {
            "instanceID": CONFIG.PMSInstanceID,
            "accountSubscriptionID": CONFIG.AccountSubscriptionID,
            "created_User": CONFIG.LoginID,
        }, { headers: { "Authorization": `Bearer ${CONFIG.AuthToken}`, "Ocp-Apim-Subscription-Key": CONFIG.API_KEY } })
            .then((res) => {

                setContactTypeList(res.data.result)
                if (props.isHistoryPresent == true) {
                    let newData = props.datatoedit.filter(x => x.is_NewEmployment == true)[0]
                    let filter = res.data.result.filter(x => x.contactTypeID == newData.contactTypeID)[0]
                    console.log(filter)
                    formik.values.newcontactType = filter
                    setDoc(!doc)
                }
                let data = {
                    options: res.data.result,
                    getOptionLabel: (option) => option.contactTypeName
                }
                setListbox(data)
                setIscontactset(true)
                setIsnewcontactset(true)
            }).catch((error) => {
                if (error.response.status == 401) {
                    localStorage.clear();
                    instance.logoutRedirect({
                        postLogoutRedirectUri: "/",
                    });
                }
            })

    }, [props])

    const formik = useFormik({
        initialValues: {
            key: 0,
            fullName: '',
            designation: '',
            email: '',
            mobileNo: '',
            telephoneNo: '',
            contactTypeID: '',
            is_Default: false,
            is_History: false,
            fromDate: false,
            additionalInfo: '',
            linkedInUrl: '',
            facebookUrl: '',
            twitterUrl: '',
            instagramUrl: '',
            externalSourceName: '',
            externalSourceUrl: '',
            linkData: '',
            contactTypeName: ''
        }
    })

    useEffect(() => {
        if (props.isHistoryPresent == true) {
            console.log(props.datatoedit)
            let history = []
            let data = props.datatoedit.filter(x => x.is_History == true)[0]
            console.log(data)
            let newData = props.datatoedit.filter(x => x.is_NewEmployment == true)[0]
            history[0] = data
            history[1] = newData
            Object.assign(formik.values, data)
            formik.values.newdesignation = newData.designation
            formik.values.newemail = newData.email
            formik.values.newmobileNo = newData.mobileNo
            formik.values.newtelephoneNo = newData.telephoneNo
            formik.values.newcontactTypeID = newData.contactTypeID
            formik.values.newfromDate = newData.fromDate
            formik.values.newFinancialInstituteID = newData.financialInstituteID
            formik.values.newkey = newData.key
            let filter = contactTypeList.filter(x => x.contactTypeID == newData.contactTypeID)[0]
            console.log(filter)
            formik.values.newcontactType = filter
            setIsnewemployment(true)
            setHistorylist(history)
        }
        else {
            Object.assign(formik.values, props.datatoedit)
        }
    }, [props])

    const toggle = () => {
        setIsModalOpen(!isModalOpen)
    }

    const saveLink = () => {
        if (linkType == 1) {
            formik.values.linkedInUrl = formik.values.linkData
        }
        else if (linkType == 2) {
            formik.values.facebookUrl = formik.values.linkData
        }
        else if (linkType == 3) {
            formik.values.twitterUrl = formik.values.linkData
        }
        else if (linkType == 4) {
            formik.values.instagramUrl = formik.values.linkData
        }
        else if (linkType == 5) {
            formik.values.externalSourceUrl = formik.values.linkData
        }
        toggle()
    }
    const openLinkedin = () => {
        setIsModalOpen(!isModalOpen)
        setLinkType(1)
        setLinkText('Paste LinkedIn Url')
        formik.values.linkData = formik.values.linkedInUrl
        setTitle('Connect Linkedin')
    }
    const openInstagram = () => {
        setIsModalOpen(!isModalOpen)
        setLinkType(4)
        setLinkText('Paste Instagram Url')
        setTitle('Connect Instagram')
        formik.values.linkData = formik.values.instagramUrl
    }
    const openTwitter = () => {
        setIsModalOpen(!isModalOpen)
        setLinkType(3)
        setLinkText('Paste Twitter Url')
        formik.values.linkData = formik.values.twitterUrl
        setTitle('Connect Twitter')

    }
    const openFacebook = () => {
        setIsModalOpen(!isModalOpen)
        setLinkType(2)
        setLinkText('Paste Facebook Url')
        formik.values.linkData = formik.values.facebookUrl
        setTitle('Connect Facebook')
    }
    const openExternal = () => {
        setIsModalOpen(!isModalOpen)
        setLinkType(5)
        formik.values.linkData = formik.values.externalSourceUrl
        setTitle('Connect')
        setLinkText('External URLs links')
    }
    const back = () => {
        props.back()
    }

    const handleFromDate = (date) => {
        console.log(date)
        formik.values.fromDate = Moment(date).format('YYYY-MM-DDTHH:mm:ss')
        setDoc(!doc)
    }
    const handletoDate = (date) => {
        console.log(date)
        formik.values.toDate = Moment(date).format('YYYY-MM-DDTHH:mm:ss')
        setDoc(!doc)
        if (isnewemployment) {
            console.log(historylist)
            let list = historylist
            console.log(props.datatoedit.key)
            let filter = list.filter(x => x.key == props.datatoedit.key)[0]
            console.log(filter)
            let index = 0
            filter.toDate = date
            list[index] = filter
            setHistorylist(list)
            console.log(list)
        }
    }
    const newhandleFromDate = (date) => {
        console.log(date)
        formik.values.newfromDate = Moment(date).format('YYYY-MM-DDTHH:mm:ss')
        setDoc(!doc)
    }

    const saveContact = () => {
        setDoc(!doc)
        if (props.isEdit) {
            if (isnewemployment) {
                let key = parseInt(props.keydata)
                let list = {
                    "financialInstituteContactID": formik.values.financialInstituteContactID,
                    "financialInstituteID": parseInt(formik.values.newFinancialInstituteID),
                    "fullName": formik.values.fullName,
                    "designation": formik.values.newdesignation,
                    "email": formik.values.newemail,
                    "mobileNo": formik.values.newmobileNo,
                    "telephoneNo": formik.values.newtelephoneNo,
                    "contactTypeID": parseInt(formik.values.newcontactTypeID),
                    "contactType": formik.values.newcontactType,
                    "contactTypeName": formik.values.contactTypeName,
                    "is_Default": true,
                    "newInstitute": null,
                    "fromDate": formik.values.newfromDate,
                    "additionalInfo": formik.values.additionalInfo,
                    "is_NewEmployment": true,
                    "linkedInUrl": formik.values.linkedInUrl,
                    "facebookUrl": formik.values.facebookUrl,
                    "twitterUrl": formik.values.twitterUrl,
                    "instagramUrl": formik.values.instagramUrl,
                    "externalSourceName": formik.values.externalSourceName,
                    "externalSourceUrl": formik.values.externalSourceUrl,
                    "contactTypeName": formik.values.contactTypeName
                }
                historylist[1] = list
                console.log(historylist)
                props.updateContact(historylist)
            }
            else {
                console.log(formik.values)
                props.updateContact(formik.values)
            }
        }
        else {
            props.saveContact(formik.values)
        }

    }

    const handleCheckEmployment = (e) => {
        if (e.target.checked) {
            setIsnewemployment(true)
            formik.values.is_History = true
            formik.values.is_newEmployment = false
            setDoc(!doc)
            setHistorylist([formik.values])
        }
        else {
            formik.values.is_History = false
            formik.values.is_newEmployment = null
            setIsnewemployment(false)
        }

    }

    const handleSelectContactType = (event, values) => {
        formik.values.contactTypeID = parseInt(values.contactTypeID)
        let filter = contactTypeList.filter(x => x.contactTypeID == parseInt(values.contactTypeID))[0]
        formik.values.contactType = filter
        formik.values.contactTypeName = filter.contactTypeName
        console.log(values)
        setDoc(!doc)
    }
    const handleContactType = (e) => {
        formik.values.contactTypeName = e.target.value
        formik.values.contactType = null
        formik.values.contactTypeID = 0
        setDoc(!doc)
    }

    const handleNewSelectContactType = (event, values) => {
        formik.values.newcontactTypeID = parseInt(values.contactTypeID)
        let filter = contactTypeList.filter(x => x.contactTypeID == parseInt(values.contactTypeID))[0]
        formik.values.newcontactType = filter
        formik.values.newcontactTypeName = filter.contactTypeName
        console.log(values)
        setDoc(!doc)
    }

    const handleNewContactType = (e) => {
        formik.values.newcontactTypeName = e.target.value
        formik.values.newcontactType = null
        formik.values.newcontactTypeID = 0
        setDoc(!doc)
    }

    return (
        <Card style={{ height: '70vh', background: 'transparent' }} >
            <Card.Body>


                <Row>
                    <Col md={9}>
                        <div className='card p-4 mb-2-rem' style={{ background: '#fff', height: '50vh', overflowY: 'scroll' }}>
                            <div className='form-title font-16 font-weight-500 '>Add Information</div>
                            <Row>
                                <FormFields.InputField
                                    md={4}
                                    name='fullName'
                                    label='Full Name*'
                                    classname='pt-1-rem'
                                    type='text'
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    val={formik.values.fullName}
                                />
                                <FormFields.InputField
                                    md={4}
                                    name='designation'
                                    label='Designation'
                                    classname='pt-1-rem'
                                    type='text'
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    val={formik.values.designation}
                                />
                                <FormFields.InputField
                                    md={4}
                                    name='email'
                                    label='Email'
                                    classname='pt-1-rem'
                                    type='text'
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    val={formik.values.email}
                                />
                                <FormFields.InputField
                                    md={4}
                                    name='mobileNo'
                                    label='Mobile Number'
                                    classname='pt-1-rem'
                                    type='text'
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    val={formik.values.mobileNo}
                                />
                                <FormFields.InputField
                                    md={4}
                                    name='telephoneNo'
                                    label='Telephone No'
                                    classname='pt-1-rem'
                                    type='text'
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    val={formik.values.telephoneNo}
                                />
                                <Col md={4} className="pt-1-rem">
                                    <div className='free-solo-add'>
                                        {iscontactset &&
                                            <Autocomplete
                                                {...listbox}
                                                id="free-solo-demo"
                                                className='br-trans'
                                                freeSolo
                                                onChange={handleSelectContactType}
                                                defaultValue={formik.values.contactType}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Contact Type" variant="standard"
                                                        onChange={handleContactType} className='br-trans' />
                                                )}
                                            />
                                        }
                                    </div>
                                </Col>
                                <FormFields.DatePick
                                    md={4}
                                    classname='pt-1-rem iconDatePicker'
                                    label='From Date'
                                    name='fromDate'
                                    val={formik.values.fromDate}
                                    handleCompletionDate={handleFromDate}
                                />
                                {isnewemployment &&

                                    <FormFields.DatePick
                                        md={4}
                                        classname='pt-1-rem iconDatePicker'
                                        label='To Date'
                                        name='toDate'
                                        val={formik.values.toDate}
                                        handleCompletionDate={handletoDate}
                                    />
                                }
                            </Row>
                            <Row>
                                {(props.isEdit == true && props.datatoedit.financialInstituteID != null) &&
                                    <Col md={4} className='pt-1-rem'>
                                        <Form.Check
                                            type='checkbox'
                                            label='Add New Employment'
                                            onChange={handleCheckEmployment}
                                            checked={isnewemployment}
                                        />
                                    </Col>
                                }
                            </Row>
                            <Row>
                                {isnewemployment &&
                                    <>
                                        <FormFields.InputSelect
                                            md={4}
                                            name='newFinancialInstituteID'
                                            label='New Institution'
                                            classname='pt-1-rem'
                                            type='text'
                                            optionField={
                                                <InsitutionList
                                                    financialInstituteID={formik.values.newFinancialInstituteID}
                                                    defualtInstitute={props.datatoedit.financialInstituteID}
                                                />}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                        <FormFields.DatePick
                                            md={4}
                                            classname='pt-1-rem iconDatePicker'
                                            label='From Date'
                                            name='newfromDate'
                                            val={formik.values.newfromDate}
                                            handleCompletionDate={newhandleFromDate}
                                        />

                                        <FormFields.InputField
                                            md={4}
                                            name='newdesignation'
                                            label='Designation'
                                            classname='pt-1-rem'
                                            type='text'
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            val={formik.values.newdesignation}
                                        />
                                        <FormFields.InputField
                                            md={4}
                                            name='newemail'
                                            label='Email'
                                            classname='pt-1-rem'
                                            type='text'
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            val={formik.values.newemail}
                                        />
                                        <FormFields.InputField
                                            md={4}
                                            name='newmobileNo'
                                            label='Mobile No'
                                            classname='pt-1-rem'
                                            type='text'
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            val={formik.values.newmobileNo}
                                        />
                                        <FormFields.InputField
                                            md={4}
                                            name='newtelephoneNo'
                                            label='Phone No'
                                            classname='pt-1-rem'
                                            type='text'
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            val={formik.values.newtelephoneNo}
                                        />
                                        <Col md={4} className="pt-1-rem">
                                            <div className='free-solo-add'>
                                                {isnewcontactset &&
                                                    <Autocomplete
                                                        {...listbox}
                                                        id="free-solo-demo"
                                                        className='br-trans'
                                                        freeSolo
                                                        onChange={handleNewSelectContactType}
                                                        defaultValue={props.isEdit == true ? formik.values.newcontactType : null}
                                                        renderInput={(params) => (
                                                            <TextField {...params} label="Contact Type" variant="standard"
                                                                onChange={handleNewContactType} className='br-trans' />
                                                        )}
                                                    />
                                                }
                                            </div>
                                        </Col>
                                    </>
                                }
                            </Row>
                            <Row>
                                <div className='form-title font-16 font-weight-500 mt-1-rem color-4F5466 d-flex'>Additional Info</div>
                            </Row>
                            <Row>
                                <FormFields.inputFieldArea
                                    md={5}
                                    name='additionalInfo'
                                    label='Write a note... eg: interests'
                                    classname='pt-1-rem'
                                    type='text'
                                    val={formik.values.additionalInfo}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Row>
                        </div>
                    </Col>
                    <Col md={3} className="p-3 " style={{ background: '#fff' }}>
                        <div className='h-100 '>
                            <div className='soc-br p-3'>
                                <div className='form-title font-14 font-weight-500  mb-3 '>Connect Social Media</div>
                                <Row>
                                    <Col md={2} >
                                        <div className='pointer' onClick={openLinkedin}><svg width="52" height="52" viewBox="0 0 46 46" fill="none" >
                                            <circle cx="22" cy="22" r="22" fill="#F0F5F8" />
                                            <path d="M18.1211 13.0132C18.1208 13.5436 17.9099 14.0522 17.5346 14.4271C17.1593 14.802 16.6505 15.0125 16.1201 15.0122C15.5897 15.0119 15.0811 14.801 14.7062 14.4257C14.3313 14.0505 14.1208 13.5416 14.1211 13.0112C14.1214 12.4808 14.3323 11.9722 14.7076 11.5973C15.0828 11.2224 15.5917 11.0119 16.1221 11.0122C16.6525 11.0125 17.1611 11.2234 17.536 11.5987C17.9109 11.974 18.1214 12.4828 18.1211 13.0132ZM18.1811 16.4932H14.1811V29.0132H18.1811V16.4932ZM24.5011 16.4932H20.5211V29.0132H24.4611V22.4432C24.4611 18.7832 29.2311 18.4432 29.2311 22.4432V29.0132H33.1811V21.0832C33.1811 14.9132 26.1211 15.1432 24.4611 18.1732L24.5011 16.4932Z" fill="#2C67FF" />
                                        </svg>
                                        </div>
                                    </Col>
                                    <Col md={2}>
                                        <div className='pointer' onClick={openFacebook}><svg width="52" height="52" viewBox="0 0 46 46" fill="none">
                                            <circle cx="22" cy="22" r="22" fill="#F0F5F8" />
                                            <path d="M24.5391 23.9155H27.0391L28.0391 19.9155H24.5391V17.9155C24.5391 16.8855 24.5391 15.9155 26.5391 15.9155H28.0391V12.5555C27.7131 12.5125 26.4821 12.4155 25.1821 12.4155C22.4671 12.4155 20.5391 14.0725 20.5391 17.1155V19.9155H17.5391V23.9155H20.5391V32.4155H24.5391V23.9155Z" fill="#2C67FF" />
                                        </svg>
                                        </div>
                                    </Col>
                                    <Col md={2}>
                                        <div className=' pointer' onClick={openTwitter}><svg width="52" height="52" viewBox="0 0 46 46" fill="none" >
                                            <circle cx="22" cy="22" r="22" fill="#F0F5F8" />
                                            <path d="M32.6994 16.0715C31.936 16.4091 31.1264 16.6309 30.2974 16.7295C31.1712 16.2069 31.8251 15.3845 32.1374 14.4155C31.3174 14.9035 30.4184 15.2455 29.4814 15.4305C28.852 14.757 28.0178 14.3104 27.1084 14.16C26.199 14.0097 25.2653 14.1639 24.4527 14.5989C23.64 15.0339 22.9938 15.7251 22.6145 16.5652C22.2352 17.4054 22.1442 18.3472 22.3554 19.2445C20.6925 19.1611 19.0657 18.729 17.5807 17.9761C16.0956 17.2233 14.7855 16.1665 13.7354 14.8745C13.3637 15.5129 13.1684 16.2387 13.1694 16.9775C13.1694 18.4275 13.9074 19.7085 15.0294 20.4585C14.3654 20.4376 13.716 20.2582 13.1354 19.9355V19.9875C13.1356 20.9532 13.4698 21.8891 14.0813 22.6365C14.6927 23.384 15.5439 23.8969 16.4904 24.0885C15.874 24.2555 15.2277 24.2801 14.6004 24.1605C14.8673 24.9917 15.3874 25.7187 16.088 26.2396C16.7886 26.7605 17.6345 27.0492 18.5074 27.0655C17.6399 27.7468 16.6466 28.2504 15.5843 28.5476C14.522 28.8448 13.4115 28.9297 12.3164 28.7975C14.2281 30.0269 16.4535 30.6796 18.7264 30.6775C26.4194 30.6775 30.6264 24.3045 30.6264 18.7775C30.6264 18.5975 30.6214 18.4155 30.6134 18.2375C31.4323 17.6456 32.139 16.9125 32.7004 16.0725L32.6994 16.0715Z" fill="#2C67FF" />
                                        </svg>
                                        </div>
                                    </Col>
                                    <Col md={2}>
                                        <div className=' pointer' onClick={openInstagram}><svg width="52" height="52" viewBox="0 0 46 46" fill="none">
                                            <circle cx="22" cy="22" r="22" fill="#F0F5F8" />
                                            <path d="M22.5391 12.4155C25.2561 12.4155 25.5951 12.4255 26.6611 12.4755C27.7261 12.5255 28.4511 12.6925 29.0891 12.9405C29.7491 13.1945 30.3051 13.5385 30.8611 14.0935C31.3696 14.5934 31.763 15.1981 32.0141 15.8655C32.2611 16.5025 32.4291 17.2285 32.4791 18.2935C32.5261 19.3595 32.5391 19.6985 32.5391 22.4155C32.5391 25.1325 32.5291 25.4715 32.4791 26.5375C32.4291 27.6025 32.2611 28.3275 32.0141 28.9655C31.7637 29.6333 31.3702 30.2381 30.8611 30.7375C30.361 31.2458 29.7564 31.6393 29.0891 31.8905C28.4521 32.1375 27.7261 32.3055 26.6611 32.3555C25.5951 32.4025 25.2561 32.4155 22.5391 32.4155C19.8221 32.4155 19.4831 32.4055 18.4171 32.3555C17.3521 32.3055 16.6271 32.1375 15.9891 31.8905C15.3214 31.64 14.7166 31.2465 14.2171 30.7375C13.7085 30.2377 13.315 29.633 13.0641 28.9655C12.8161 28.3285 12.6491 27.6025 12.5991 26.5375C12.5521 25.4715 12.5391 25.1325 12.5391 22.4155C12.5391 19.6985 12.5491 19.3595 12.5991 18.2935C12.6491 17.2275 12.8161 16.5035 13.0641 15.8655C13.3143 15.1977 13.7079 14.5928 14.2171 14.0935C14.7167 13.5848 15.3215 13.1913 15.9891 12.9405C16.6271 12.6925 17.3511 12.5255 18.4171 12.4755C19.4831 12.4285 19.8221 12.4155 22.5391 12.4155ZM22.5391 17.4155C21.213 17.4155 19.9412 17.9423 19.0035 18.88C18.0658 19.8177 17.5391 21.0894 17.5391 22.4155C17.5391 23.7416 18.0658 25.0134 19.0035 25.9511C19.9412 26.8887 21.213 27.4155 22.5391 27.4155C23.8651 27.4155 25.1369 26.8887 26.0746 25.9511C27.0123 25.0134 27.5391 23.7416 27.5391 22.4155C27.5391 21.0894 27.0123 19.8177 26.0746 18.88C25.1369 17.9423 23.8651 17.4155 22.5391 17.4155ZM29.0391 17.1655C29.0391 16.834 28.9074 16.5161 28.6729 16.2816C28.4385 16.0472 28.1206 15.9155 27.7891 15.9155C27.4575 15.9155 27.1396 16.0472 26.9052 16.2816C26.6708 16.5161 26.5391 16.834 26.5391 17.1655C26.5391 17.497 26.6708 17.815 26.9052 18.0494C27.1396 18.2838 27.4575 18.4155 27.7891 18.4155C28.1206 18.4155 28.4385 18.2838 28.6729 18.0494C28.9074 17.815 29.0391 17.497 29.0391 17.1655ZM22.5391 19.4155C23.3347 19.4155 24.0978 19.7316 24.6604 20.2942C25.223 20.8568 25.5391 21.6199 25.5391 22.4155C25.5391 23.2112 25.223 23.9742 24.6604 24.5368C24.0978 25.0995 23.3347 25.4155 22.5391 25.4155C21.7434 25.4155 20.9804 25.0995 20.4177 24.5368C19.8551 23.9742 19.5391 23.2112 19.5391 22.4155C19.5391 21.6199 19.8551 20.8568 20.4177 20.2942C20.9804 19.7316 21.7434 19.4155 22.5391 19.4155Z" fill="#2C67FF" />
                                        </svg>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <div className='form-title font-14 font-weight-500 mt-2-rem mb-2'>External Links &nbsp;&nbsp;
                                        <span className='link_icon_bgs pointer' onClick={openExternal}><img src='assets/images/link-icon.svg' /></span>
                                    </div>
                                    <div>
                                        {formik.values.externalSourceName != '' &&
                                            <>
                                                <br />
                                                <div>{formik.values.externalSourceName}</div>
                                                <div><a href={formik.values.externalSourceUrl}>{formik.values.externalSourceUrl}</a></div>
                                            </>
                                        }
                                    </div>
                                </Row>
                            </div>
                            <Row className='mt-2-rem align-items-end'>
                                <Col md={12} className='d-flex justify-content-end'>
                                    <span><BlueBorderButton value='Cancel' /></span>
                                    <span className='pl-10 '><BlueButton className='font-weight-500' value='Save Contact' clickEvent={saveContact} /></span>

                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Card.Body>
            <Card.Footer className='form-card-footer pt-4 d-flex'>
                <span><BlueBorderButton value='Back' clickEvent={back} /></span>
            </Card.Footer>
            <>
                <Modal isOpen={isModalOpen} toggle={toggle} className='mt-10-rem property_info_modal mt-5'>
                    <ModalHeader toggle={toggle}>
                        <div className='font-16 font-weight-600 color-707895'>{title}</div>
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col md={1}></Col>
                            {linkType == 5 &&
                                <FormFields.InputField
                                    md={11}
                                    name='externalSourceName'
                                    label='Source Name'
                                    classname='pt-1-rem no_padding_left'
                                    type='text'
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    val={formik.values.externalSourceName}
                                />
                            }
                        </Row>
                        <Row className='d-flex plr-2-rem'>
                            <Col md={1}></Col>
                            <Col md={1} className='d-flex align-items-center http_linkssss'>Url</Col>
                            <FormFields.InputField
                                md={9}
                                classname='mb-3 left_no_padding'
                                name='linkData'
                                label={linkText}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                val={formik.values.linkData}
                            />
                        </Row>
                    </ModalBody>
                    <ModalFooter className='d-flex justify-content-start' >
                        <CancelButton value='Cancel' clickEvent={toggle} />
                        <BlueButton value='Add' clickEvent={saveLink} />
                    </ModalFooter>
                </Modal>
            </>
        </Card>

    )
}
